module.exports = __webpack_public_path__ + "img/icon_yctgl.3d0d563a.png";